import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import '../../css/pages/HorecaFaq.css'

// HORECA FAQ: native <details> accordion (no lib) + FAQPage JSON-LD. The schema
// mirrors the visible Q&A — its value here is AI/LLM citation (GEO), not Google
// rich results (those are gov/healthcare only).
export const HorecaFaq = () => {
  const { t } = useTranslation('global')
  const raw = t('horeca.faq.items', { returnObjects: true })
  const items = Array.isArray(raw) ? raw : []

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((it) => ({
      '@type': 'Question',
      name: it.q,
      acceptedAnswer: { '@type': 'Answer', text: it.a },
    })),
  }

  return (
    <section id="horeca-faq" className="horeca-faq">
      {items.length > 0 && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>
      )}
      <h2 className="horeca-faq-title">{t('horeca.faq.title')}</h2>
      <div className="horeca-faq-list">
        {items.map((item, i) => (
          <details key={i} className="horeca-faq-item">
            <summary className="horeca-faq-q">{item.q}</summary>
            <p className="horeca-faq-a">{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  )
}
